import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import { withTheme } from '@mui/styles';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { IWatermarkInfo } from '@interfaces/learning';

type Props = {
  watermarkInfo: IWatermarkInfo;
};

const Watermark = ({ watermarkInfo }: Props) => {
  const { t } = useTranslation('common');
  const [isShow, setIsShow] = useState(false);
  const [datetime, setDatetime] = useState<string>();

  useEffect(() => {
    if (watermarkInfo) {
      if (watermarkInfo.datetime !== datetime) {
        setDatetime(watermarkInfo.datetime);
        setIsShow(true);
      }
    }
  }, [watermarkInfo]);

  useEffect(() => {
    if (isShow) {
      const countdown = setTimeout(() => {
        setIsShow(false);
      }, 3000);
      return () => {
        setIsShow(false);
        clearTimeout(countdown);
      };
    }
  }, [isShow]);

  return (
    <Container className={isShow ? '' : ' hide'}>
      <Typography>
        {t('learning_page.watermark.topic', {
          firstname: watermarkInfo?.firstname,
          lastname: watermarkInfo?.lastname,
          email: watermarkInfo?.email,
        })}
      </Typography>
      <Typography>
        IP: {watermarkInfo?.ip} {watermarkInfo?.datetime}
      </Typography>
      <Typography />
      <Typography>{t('learning_page.watermark.description')}</Typography>
    </Container>
  );
};

export default Watermark;

const Container = withTheme(styled.div`
  position: absolute;
  padding: 8px;
  left: 50%;
  transform: translate(-50%, 0);
  color: white;
  font-weight: 400;
  font-size: 24px;
  text-align: center;
  width: 100%;
  opacity: 0.8;
  background: rgba(111, 111, 111, 0.5);
  text-shadow: 1px 1px 2px #000;
  white-space: pre-wrap;
  z-index: 1;

  &.hide {
    display: none;
  }
`);
